import React from 'react';
import Loadable from 'react-loadable';

export const asyncComponent = loader =>
  Loadable({
    loader,
    loading: () => <></>,
  });
